(function () {
  // Mobile menu
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.getElementById('mobile-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var opening = nav.hidden;
      nav.hidden = !opening;
      toggle.setAttribute('aria-expanded', String(opening));
    });
  }

  // Auto-submit sort select
  document.querySelectorAll('[data-autosubmit]').forEach(function (el) {
    el.addEventListener('change', function () { el.form.submit(); });
  });

  // Country selects in address forms
  document.querySelectorAll('select[data-default]').forEach(function (sel) {
    var d = sel.getAttribute('data-default');
    if (d) sel.value = d;
  });

  // Product page: variant pills + gallery
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var json = root.querySelector('[data-product-json]');
    if (!json) return;
    var data = JSON.parse(json.textContent);
    var variants = data.variants || [];
    var fmt = data.money_format || '${{amount}}';
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var btn = root.querySelector('[data-atc]');
    var mainImg = root.querySelector('[data-main-img]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-media-id]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('.opt'));

    function money(cents) {
      var parts = (cents / 100).toFixed(2).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, whole + '.' + parts[1]);
    }

    function showMedia(button) {
      if (!mainImg || !button) return;
      mainImg.src = button.getAttribute('data-src');
      mainImg.alt = button.getAttribute('data-alt') || '';
      mainImg.removeAttribute('srcset');
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t === button ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t); }); });

    groups.forEach(function (group) {
      group.addEventListener('change', function () {
        var selected = groups.map(function (g) {
          var c = g.querySelector('input:checked');
          return c ? c.value : null;
        });
        groups.forEach(function (g, i) {
          var label = g.querySelector('[data-option-label]');
          if (label) label.textContent = selected[i];
        });
        var v = variants.find(function (x) {
          return x.options.every(function (o, i) { return o === selected[i]; });
        });
        if (!v) {
          btn.disabled = true;
          btn.textContent = 'Unavailable';
          return;
        }
        idInput.value = v.id;
        priceEl.innerHTML = v.compare_at_price > v.price
          ? '<span class="price-sale">' + money(v.price) + '</span> <s class="price-was">' + money(v.compare_at_price) + '</s>'
          : money(v.price);
        btn.disabled = !v.available;
        btn.textContent = v.available ? 'Add to cart' : 'Sold out';
        if (v.featured_media) {
          var match = thumbs.find(function (t) { return t.getAttribute('data-media-id') === String(v.featured_media.id); });
          if (match) showMedia(match);
        }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(null, '', url.toString());
        } catch (e) {}
      });
    });
  });
})();
